import { classNames } from "primereact/utils";
import styles from "./SelectField.module.scss";
import { RenderWhen } from "../../../../infrastructure/components/RenderWhen";
import { useSelectField } from "./hooks/useSelectField";
import { AppDropDown } from "./abstract/AppDropDown";
import { useAppContext } from "../../../../../AppContext";

import { dvSize } from "../../../../infrastructure/utilities/viewportUnitsUtility";
interface ISelectFieldProps<TOption> {
  options: TOption[];
  disabled?: boolean;
  className?: string;
  filter?: boolean;
  value?: number;
  editable?: boolean;
  width?: string;
  defaultValue?: string;
  label?: string;
  includeId?: boolean;
  required?: boolean;
  onChange?: (value: number | null) => void;
}

export const SelectField = <TOption,>({
  options,
  disabled,
  className,
  filter,
  value,
  editable = false,
  width,
  defaultValue,
  label,
  includeId = true,
  required,
  onChange,
}: ISelectFieldProps<TOption>) => {
  const { isFocused, onFocus, onBlur } = useSelectField();
  const { isDesktopOrTablet } = useAppContext();

  if (!width) {
    width = isDesktopOrTablet ? "600px" : dvSize("80dvw");
  }

  return (
    <div
      style={{ width: width }}
      className={classNames(styles.root, className)}
    >
      <RenderWhen condition={!!label}>
        <div
          className={classNames(styles.root_label, {
            [styles.root_label_interacted_with]: true,
          })}
        >
          {label}
          {required ? "*" : ""}
        </div>
      </RenderWhen>

      <AppDropDown
        options={options}
        disabled={disabled}
        filter={filter}
        editable={editable}
        value={value}
        className={styles.root_dropdown}
        width={width}
        defaultValue={defaultValue}
        includeId={includeId}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
      />
    </div>
  );
};
